// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"943c42d1","902":"7775dc29"}[chunkId] + ".chunk.css";
};